<div class="content">
    <div class="container-fluid">
        <div class="page-title-box">
            <div class="page-title-right">
                <a role="button" class="btn btn-primary btn-sm" href="javascript:;" (click)="onAddPackage()">
                    <i class="fe-plus mr-1"></i> Add Package
                </a>
                <button class="btn btn-secondary btn-sm ml-1" type="button" (click)="filters.hidden = !filters.hidden"><i class="fe-filter mr-1"></i> {{filters.hidden ? 'Show' : 'Hide'}} Filters</button>
            </div>
            <h4 class="page-title">Packages</h4>
        </div>
        <div class="card-box filters-box" *ngIf="!filters.hidden">
            <h4 class="filters-title text-primary font-weight-bold"><i class="fe-filter mr-1"></i>Filters</h4>
            <div class="row row-sm p-1">
                <div class="col-2 col">
                    <div class="form-group font-13 mb-0">
                        <label class="mb-0 font-13 font-weight-semibold">Package Name</label>
                        <input type="text" class="form-control" maxlength="100" block [(ngModel)]="filters.options.packageName" placeholder="Enter package name" autocomplete="off" />
                    </div>
                </div>
                <div class="col-3 col">
                    <div class="row row-sm">
                        <div class="col-6 col">
                            <div class="form-group mb-0">
                                <label class="mb-0 font-13 font-weight-semibold">Module Type</label>
                                <ng-select placeholder="Select module type" [(ngModel)]="filters.options.moduleType" [items]="moduleTypes" [loading]="loadingModuleTypes" bindLabel="name" bindValue="name">
                                    <ng-template ng-option-tmp let-item="item">
                                        <div class="media font-13">
                                            <div class="avatar-xs mr-1">
                                                <span class="avatar-title rounded-circle font-11 font-weight-bold bg-soft-warning text-primary">
                                                    <i class="mdi mdi-tag-text-outline"></i>
                                                </span>
                                            </div>
                                            <div class="media-body overflow-hidden" [textContent]="item.name"></div>
                                        </div>
                                    </ng-template>
                                    <ng-template ng-label-tmp let-item="item">
                                        <div class="media font-13">
                                            <div class="avatar-xs mr-1">
                                                <span class="avatar-title rounded-circle font-11 font-weight-bold bg-soft-warning text-primary">
                                                    <i class="mdi mdi-tag-text-outline"></i>
                                                </span>
                                            </div>
                                            <div class="media-body overflow-hidden" [textContent]="item.name"></div>
                                        </div>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-6 col">
                            <div class="form-group mb-0">
                                <label class="mb-0 font-13 font-weight-semibold">Package Type</label>
                                <ng-select placeholder="Select package type" [(ngModel)]="filters.options.packageType" [items]="packageTypes" [loading]="loadingPackageTypes" bindLabel="name" bindValue="name">
                                    <ng-template ng-option-tmp let-item="item">
                                        <div class="media font-13">
                                            <div class="avatar-xs mr-1">
                                                <span class="avatar-title rounded-circle font-11 font-weight-bold bg-soft-warning text-primary">
                                                    <i class="fe-tag"></i>
                                                </span>
                                            </div>
                                            <div class="media-body overflow-hidden" [textContent]="item.name"></div>
                                        </div>
                                    </ng-template>
                                    <ng-template ng-label-tmp let-item="item">
                                        <div class="media font-13">
                                            <div class="avatar-xs mr-1">
                                                <span class="avatar-title rounded-circle font-11 font-weight-bold bg-soft-warning text-primary">
                                                    <i class="fe-tag"></i>
                                                </span>
                                            </div>
                                            <div class="media-body overflow-hidden" [textContent]="item.name"></div>
                                        </div>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-2 col">
                    <div class="form-group mb-0">
                        <label class="mb-0 font-13 font-weight-semibold">Location</label>
                        <ng-select [items]="locations"
                                   [loading]="loadingLocations"
                                   [clearable]="true"
                                   bindLabel="name"
                                   bindValue="id"
                                   placeholder="Select location"
                                   [(ngModel)]="filters.options.locationId">
                            <ng-template ng-option-tmp let-item="item">
                                <div class="media font-13">
                                    <div class="avatar-xs mr-1">
                                        <span class="avatar-title rounded-circle font-11 font-weight-bold bg-soft-warning text-primary">
                                            <i class="fe-map-pin"></i>
                                        </span>
                                    </div>
                                    <div class="media-body overflow-hidden">
                                        <span class="font-weight-semibold" [textContent]="item.value"></span>
                                        <small class="text-mute text-capitalize ml-1" [textContent]="'(' + item.optionalText + ')'"></small>
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template ng-label-tmp let-item="item">
                                <div class="media font-13">
                                    <div class="avatar-xs mr-1">
                                        <span class="avatar-title rounded-circle font-11 font-weight-bold bg-soft-warning text-primary">
                                            <i class="fe-map-pin"></i>
                                        </span>
                                    </div>
                                    <div class="media-body overflow-hidden">
                                        <span class="font-weight-semibold" [textContent]="item.value"></span>
                                        <small class="text-mute text-capitalize ml-1" [textContent]="'(' + item.optionalText + ')'"></small>
                                    </div>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
                <div class="col-2 col">
                    <div style="margin-top: 20px;">
                        <button type="button" (click)="onApplyFilters()" class="btn btn-sm btn-outline-primary">Search</button>
                        <button type="button" (click)="onResetFilters()" class="btn btn-sm btn-outline-danger ml-1">Reset</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex align-items-center" *ngIf="page.loading">
            <span class="spinner-grow text-warning" role="status" aria-hidden="true"></span>
            <span class="ml-2">Please wait while loading Packages ...</span>
        </div>
        <div class="mh-400 position-relative" *ngIf="!page.loading && !packages?.length">
            <no-data [applied]="filters.applied" [title]="'Packages'"></no-data>
        </div>
        <div class="card mb-0" *ngIf="!page.loading && packages?.length">
            <div class="card-body p-0">
                <div class="table-responsive">
                    <table class="table table-centered table-sm table-striped table-bordered mb-0">
                        <thead>
                            <tr>
                                <th>Package</th>
                                <th>Location</th>
                                <th>Doctor</th>
                                <th class="text-right">Quantity</th>
                                <th class="text-right">Discount</th>
                                <th class="text-right">Expires In</th>
                                <th>Status</th>
                                <th class="text-right">Actions</th>
                            </tr>
                        </thead>
                        <tbody class="font-13">
                            <tr *ngFor="let item of packages; let i = index; trackBy: trackBy.package" [class.selected]="selectedPackage?.packageModuleId === item.packageModuleId">
                                <td>
                                    <p class="title mb-0 font-weight-semibold text-capitalize" [textContent]="item.packageName"></p>
                                    <small class="text-mute">
                                        <span [textContent]="item.moduleTypeName + ' / '"></span>
                                        <span [textContent]="item.packageTypeName"></span>
                                    </small>
                                </td>
                                <td>
                                    <p class="mb-0 text-capitalize" [textContent]="item.locationName"></p>
                                    <small class="text-mute" [textContent]="item.templateName"></small>
                                </td>
                                <td>
                                    <ng-container *ngIf="item.providerName">
                                        <p class="mb-0 text-capitalize" [textContent]="item.providerName"></p>
                                        <small class="text-mute" [textContent]="item.departmentName"></small>
                                    </ng-container>
                                    <span *ngIf="!item.providerName">-</span>
                                </td>
                                <td class="text-right" [textContent]="item.quantity"></td>
                                <td class="text-right">
                                    <ng-container *ngIf="item.discountType">
                                        <span *ngIf="item.discountPercentage" [textContent]="item.discountPercentage + '%'"></span>
                                        <span *ngIf="item.discountAmount" [textContent]="item.discountAmount | currency :'₹ ':'symbol':'1.2-2'"></span>
                                    </ng-container>
                                    <span *ngIf="!item.discountType">-</span>
                                </td>
                                <td class="text-right">
                                    <ng-container *ngIf="item.expiresIn">
                                        <span [textContent]="item.expiresIn"></span>
                                        <small class="ml-1 font-11 text-mute" [textContent]="'days'"></small>
                                    </ng-container>
                                    <span *ngIf="!item.expiresIn">-</span>
                                </td>
                                <td>
                                    <ng-template #modifiedBy>
                                        <label class="font-13 font-weight-bold">
                                            <span *ngIf="item.active">Last Modified By</span>
                                            <span *ngIf="!item.active">Disabled By</span>
                                        </label>
                                        <div class="d-block">
                                            <p class="mb-0 text-capitalize font-weight-semibold font-13 text-dark" [textContent]="item.modifiedByName || item.createdByName"></p>
                                            <small class="font-11 text-mute" [textContent]="(item.modifiedDate || item.createdDate) | date: 'dd-MM-yyyy, hh:mm a'"></small>
                                        </div>
                                    </ng-template>
                                    <span class="badge badge-success" *ngIf="item.active && !item.isInUse" placement="left" [ngbPopover]="modifiedBy" triggers="mouseenter:mouseleave">Active</span>
                                    <span class="badge badge-danger" *ngIf="!item.active && !item.isInUse" placement="left" [ngbPopover]="modifiedBy" triggers="mouseenter:mouseleave">Disabled</span>
                                    <span class="badge badge-primary" *ngIf="item.isInUse" placement="left" [ngbPopover]="modifiedBy" triggers="mouseenter:mouseleave">Is In Use</span>
                                </td>
                                <td>
                                    <div class="d-flex align-items-center justify-content-end">
                                        <a href="javascript:;" class="action-icon text-info" (click)="onOpenModal(templateConsentForm,0, item)"  placement="left" ngbTooltip="Update Consent"><i class="fe-file-plus"></i></a>

                                        <a href="javascript:;" class="action-icon text-info" (click)="onOpenDocumentModal(templateUploadDocument, item)" placement="left" ngbTooltip="Upload Document"><i class="fe-arrow-up"></i></a>
                                        <a href="javascript:;" *ngIf="item.packageDocumentId >0" class="action-icon text-info" (click)="onOpenViewDocumentModal(templateViewDocument, item)" placement="left" ngbTooltip="View Document"><i class="fe-download"></i></a>

                                        <a href="javascript:;" (click)="onOpenModal(templateViewPackage, 0, item)" class="action-icon text-info" placement="left" ngbTooltip="View Package"><i class="fe-eye"></i></a>
                                        <a href="javascript:;" *ngIf="item.active && !item.isInUse" (click)="onEditPackage(item.encryptedPackageModuleId)" class="action-icon text-primary ml-1" placement="left" ngbTooltip="Edit Package"><i class="mdi mdi-pencil"></i></a>
                                        <a href="javascript:;" *ngIf="item.active && !item.isInUse" class="action-icon text-danger ml-1" placement="left" ngbTooltip="Disable" (click)="onModifyStatus(item, false)">
                                            <i *ngIf="item.isModifying" class="mdi mdi-spin mdi-loading"></i>
                                            <i *ngIf="!item.isModifying" class="fe-x-circle"></i>
                                        </a>
                                        <a href="javascript:;" *ngIf="!item.active && !item.isInUse" class="action-icon text-success ml-1" placement="left" ngbTooltip="Enable" (click)="onModifyStatus(item, true)">
                                            <i *ngIf="item.isModifying" class="mdi mdi-spin mdi-loading"></i>
                                            <i *ngIf="!item.isModifying" class="fe-check-circle"></i>
                                        </a>
                                        <a href="javascript:;" *ngIf="!item.isInUse" class="action-icon text-warning ml-1" placement="left" ngbTooltip="Delete" (click)="onDelete(item)">
                                            <i *ngIf="item.isDeleting" class="mdi mdi-spin mdi-loading"></i>
                                            <i *ngIf="!item.isDeleting" class="fe-trash-2"></i>
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot *ngIf="pagination.totalPages > 1">
                            <tr>
                                <td colspan="8">
                                    <nav class="d-flex align-items-center justify-content-between p-2">
                                        <p class="mb-0 font-13">
                                            <span class="text-dark">Page <span [textContent]="pagination.currentPage"></span> of <span [textContent]="pagination.totalPages"></span></span>
                                            <span class="ml-1">
                                                <span>(Showing <span [textContent]="pagination.currentItems - packages.length + 1"></span> - <span [textContent]="pagination.currentItems"></span> of <span [textContent]="pagination.totalItems"></span> Packages)</span>
                                            </span>
                                        </p>
                                        <ngb-pagination class="pagination justify-content-end" [maxSize]="5" [rotate]="true" [(page)]="pagination.pageIndex" [pageSize]="pagination.pageSize" (pageChange)="onNextPage()" [collectionSize]="pagination.totalItems">
                                            <ng-template ngbPaginationPrevious><i class="fe-arrow-left"></i></ng-template>
                                            <ng-template ngbPaginationNext><i class="fe-arrow-right"></i></ng-template>
                                        </ngb-pagination>
                                    </nav>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #templateViewPackage>
    <div class="modal-header d-block">
        <div class="d-flex align-items-center justify-content-between">
            <h4 class="modal-title">
                <i class="mdi mdi-package-variant mr-1"></i>View Package
            </h4>
            <div>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="onCloseModal();">×</button>
            </div>
        </div>
    </div>
    <div class="modal-body p-0" style="min-height: 400px">
        <view-package-module [packageModuleId]="selectedPackage.packageModuleId"></view-package-module>
    </div>
</ng-template>


<ng-template #templateUploadDocument>
    <form [formGroup]="uploadDocumentForm" (ngSubmit)="onSubmitDocument()">
        <div class="modal-header">
            <h4 class="modal-title"><i class="mdi mdi-file-multiple mr-1"></i>Upload Documents</h4>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="onCloseModal();">×</button>
        </div>
        <div class="modal-body">
            <div class="row appointment-form bg-pattern bg-light mb-3">
                <div class="col-md-4">
                    <div class="form-group mb-0">
                        <label class="mb-1">Document Name <code>*</code></label>
                        <input type="text" autofocus formControlName="documentName" maxlength="100" block autocomplete="nope" class="form-control" [ngClass]="{ 'is-invalid': (submitted && form.documentName.errors) }" placeholder="Enter document name" />
                        <div *ngIf="form.documentName.errors" class="invalid-feedback show-must">
                            <p *ngIf="form.documentName.errors.whiteSpaces">Please remove white spaces.</p>
                        </div>
                    </div>
                </div>
            </div>
            <file-dropper [expandable]="true"
                          [maxFiles]="maxFiles"
                          [maxFileSize]="10000"
                          [accept]="'application/pdf, image/jpeg, image/pjpeg, image/png, image/gif, video/mp4'"
                          (onSelectEmitter)="onFileSelect($event)">
            </file-dropper>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default btn-sm" (click)="onCloseModal();">Cancel</button>
            <button type="submit" [disabled]="submitting" class="btn btn-primary btn-sm ml-1">
                <span *ngIf="submitting">
                    <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                    Please wait..
                </span>
                <span *ngIf="!submitting">Submit</span>
            </button>
        </div>
    </form>
</ng-template>


<ng-template #templateViewDocument>
    <ng-container *ngIf="document">
        <div class="modal-header">
            <h4 class="modal-title"><span [textContent]="document.documentName">{{document | json}}</span><small class="ml-2"></small></h4>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="onCloseModal();">×</button>
        </div>
        <div class="modal-body">
            <a href="javascript:;" (click)="onPrevious()" class="previous-document" title="Previous document" *ngIf="showPrevious"><i class="mdi mdi-arrow-left-bold"></i></a>
            <a href="javascript:;" (click)="onNext()" class="next-document" title="Next document" *ngIf="showNext"><i class="mdi mdi-arrow-right-bold"></i></a>
            <div class="p-3" *ngIf="loadingDocument">
                <div class="d-flex align-items-center">
                    <span class="spinner-border text-primary" role="status" aria-hidden="true"></span>
                    <span class="ml-3">Please wait while loading Document ...</span>
                </div>
            </div>
            <div *ngIf="!loadingDocument && documentError">
                <div class="position-relative mh-400">
                    <no-data title="Document"></no-data>
                </div>
            </div>
            <ng-container *ngIf="document && document.isImage">
                <img [src]="document.formedUrl" [hidden]="loadingDocument || documentError" (load)="onDocumentLoad()" (error)="onDocumentError()" [alt]="document.documentName" />
            </ng-container>
            <ng-container *ngIf="document && document.isVideo">
                <video style="width: 100%; height: 100%" controls (click)="toggleVideo()" #videoPlayer autoplay>
                    <source [src]="document.formedUrl" (load)="onDocumentLoad()" [type]="document.contentType">
                </video>
            </ng-container>
            <ng-container *ngIf="document && !document.isImage && !document.isVideo">
                <pdf-viewer [src]="document.formedUrl['changingThisBreaksApplicationSecurity']"
                            [render-text]="true"
                            [autoresize]="true"
                            [original-size]="false"
                            [fit-to-page]="false"
                            (on-progress)="onProgress($event)"
                            (error)="onDocumentError()"
                            style="width: 100%; height: 500px">
                </pdf-viewer>
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<ng-template #templateConsentForm>
    <form [formGroup]="consentForm" (ngSubmit)="updateConsentForm()">
        <div class="modal-header d-flex justify-content-between">
            <div>
                <h4 class="modal-title">Update Consent Form</h4>
            </div>
            <div>
                <button type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-hidden="true"
                        (click)="onCloseModal();">
                    ×
                </button>
            </div>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label class="mb-1">Consent Form <code>*</code></label>
                        <ng-select class="ng-select-sm text-uppercase"
                                   [items]="consentFormIds"
                                   bindLabel="name"
                                   autocomplete="nope"
                                   placeholder="Select consent forms"
                                   formControlName="consentFormIds"
                                   [ngClass]="{ 'is-invalid': updatedConsentIds && forms.consentFormIds.errors }"
                                   [multiple]="true">
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm" let-item="item">
                                <div class="ng-option disabled">
                                    no consent form found for '{{searchTerm}}'
                                </div>
                                <div class="media-body overflow-hidden">
                                    <span class="font-weight-semibold" [textContent]="item.name"></span>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-light" (click)="onCloseModal()">
                <i class="mdi mdi-close mr-1"></i>Close
            </button>
            <button type="submit" class="btn btn-sm btn-primary" [disabled]="submitting" >
                <span *ngIf="!updattingConsentIds"> <i class="mdi mdi-check mr-1"></i>Submit </span>
                <span *ngIf="updattingConsentIds">
                    <span class="spinner-border spinner-border-sm mr-1"
                          role="status"
                          aria-hidden="true"></span>
                    Please wait..
                </span>
            </button>
        </div>
        </form>
</ng-template>